export const APP_SCHEMA_VERSION = '2025-11-12';
export const SCHEMA_VERSION_STORAGE_KEY = 'one-score.schema-version';
